<div class="row">
	<div class="col-15 col-md-15 col-sm-24">
		<div class="margin-extra">
			<!-- Title -->
			<div class="margin-bottom-15">
				<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
			</div>

			<!-- Description -->
			<ngx-skeleton-loader count="2" [theme]="{ width: '100%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
		</div>
	</div>
</div>

<div class="table-container padding-bottom-30">
	<table cellspacing="0" cellpadding="0">
		<thead>
			<tr>
				<td *ngFor="let column of GHOST_COLUMNS">
					<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				</td>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of GHOST_ROWS">
				<td *ngFor="let column of GHOST_COLUMNS">
					<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- Disclosure -->
<div class="disclosure">
	<ngx-skeleton-loader count="5" [theme]="{ width: '100%', 'margin-bottom': '15px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
</div>

<hr class="margin-extra" />
